import React from 'react';
import { hasPageAccess } from '../../helper/permissionHelper';

export const withPageAccess = (Component, requiredPermission) => {
  return (props) => {
    const hasAccess = hasPageAccess(props.user?.user_level, requiredPermission);

    if (!hasAccess) {
      return (
        <div className="container-fluid pt-4">
          <h5 className="text-center pt-4">Anda tidak punya akses ke halaman ini.</h5>
        </div>
      );
    }

    return <Component {...props} />;
  };
};
